import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaAgendamento from './Components/TabelaAgendamento'


function ModeloAgendamento() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox', isVisible: true },
      { label: 'ID', key: 'id', isVisible: true },
      { label: 'Tipo de Janela', key: 'tipo', isVisible: true },
      { label: 'Descrição', key: 'Agendamento', isVisible: true },
      { label: 'Hora Inicial', key: 'horaInicial', isVisible: true },
      { label: 'Hora Fim', key: 'horaFim', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];
    
    const mockPermissions = [
      {
        id: 450,
        tipo: 'Carregamento',
        Agendamento: 'Refrigerado',
        horaInicial: '12:30',
        horaFim: '15:55',
        ativo: true,
      },
      {
        id: 481,
        tipo: 'Recebimento',
        Agendamento: 'Seco',
        horaInicial: '14:45',
        horaFim: '18:20',
        ativo: false,
      },
      {
        id: 500,
        tipo: 'Expedição',
        Agendamento: 'Congelado',
        horaInicial: '18:10',
        horaFim: '22:15',
        ativo: true,
      },
    ];
    

    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {

    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Janela de Agendamento'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        
        
          <div id="print-content" ref={printRef}>
              <TabelaAgendamento headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default ModeloAgendamento